/*
 *
 * ToastMessages constants
 *
 */
export const REDUCER_KEY = 'ToastMessages';
export const ADD_MESSAGE = 'app/ToastMessages/ADD_MESSAGE';
export const REMOVE_MESSAGE = 'app/ToastMessages/REMOVE_MESSAGE';
